import { isClient } from "../globals";
import { SourceItem } from "../shared/models/source-item.model";

const FAVORITES_SUFFIX = ".favorites";

/**
 * Sanitizes site name for use in localStorage key: keep only digits, letters, and whitespace.
 */
export function getFavoritesKey(siteName: string): string {
    const sanitized = siteName.replace(/[^\dA-Za-z\s]/g, "");
    return `${sanitized}${FAVORITES_SUFFIX}`;
}

/**
 * Returns the list of favorites for the given storage key.
 * SSR-safe: returns empty array when not in client.
 */
export function getFavorites(siteKey: string): SourceItem[] {
    if (!isClient) return [];
    try {
        const raw = window.localStorage.getItem(siteKey);
        if (raw == null) return [];
        const parsed = JSON.parse(raw) as SourceItem[];
        return Array.isArray(parsed) ? parsed : [];
    } catch {
        return [];
    }
}

/**
 * Persists the list of favorites for the given storage key.
 * SSR-safe: no-op when not in client.
 */
export function setFavorites(siteKey: string, items: SourceItem[]): void {
    if (!isClient) return;
    try {
        window.localStorage.setItem(siteKey, JSON.stringify(items));
    } catch {
        // ignore storage errors
    }
}
